import {
  Button,
  ICONS,
  PLATFORM_THEME_COLORS,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

import {
  MainContainer,
  ElementContainer,
  GridElement,
  GridContainer,
  ButtonContainer,
} from './main-info.styles';
import { IMainInfoProps } from './main-info.interfaces';
import { formatByMask } from 'src/common/helpers/common.helpers';

const MainInfo = ({ openEdit, data }: IMainInfoProps) => {
  const { t } = useTranslation(['common', 'settings']);

  return (
    <MainContainer>
      <GridContainer className="container">
        <GridElement>
          <ElementContainer>
            <Typography weight="bold">{t('labels.firstName')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {data.profile.firstName}
            </Typography>
          </ElementContainer>
          <ElementContainer>
            <Typography weight="bold">{t('labels.lastName')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {data.profile.lastName}
            </Typography>
          </ElementContainer>
          <ElementContainer>
            <Typography weight="bold">{t('labels.phoneNumber')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {formatByMask(data.profile.phoneNumber, '+## ### ### #######')}
            </Typography>
          </ElementContainer>
        </GridElement>
        <GridElement>
          <ElementContainer>
            <Typography weight="bold">
              {t('settings:userManagementSettings.labels.position')}:
            </Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {data.companyPosition.name || '-'}
            </Typography>
          </ElementContainer>
          <ElementContainer>
            <Typography weight="bold">{t('labels.permission')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {data.account.permissionGroup}
            </Typography>
          </ElementContainer>
          <ElementContainer>
            <Typography weight="bold">{t('labels.language')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {data.profile.language && t(`languages.${data.profile.language}`)}
            </Typography>
          </ElementContainer>
        </GridElement>
        <GridElement>
          <ElementContainer>
            <Typography weight="bold">{t('labels.email')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {data.account.email}
            </Typography>
          </ElementContainer>
        </GridElement>
      </GridContainer>
      <ButtonContainer>
        <Button
          onClick={() => openEdit(true)}
          icon={ICONS.edit}
          ghost
          type="primary"
          iconColor={PLATFORM_THEME_COLORS.primary.blue}
        >
          {t('buttons.edit')}
        </Button>
      </ButtonContainer>
    </MainContainer>
  );
};

export default MainInfo;
